// Mock data for Maged Hikal's portfolio
// This will be replaced with real backend data later

export const personalInfo = {
  name: "Maged Hikal",
  title: "Senior Software Developer | Full Stack Developer",
  tagline: "Building scalable solutions with .NET, React, and Cloud Technologies",
  bio: "With 8 years of experience in software development, I specialize in .NET C#, React, Angular, and cloud architecture. I've delivered robust solutions across various industries, from AI-driven eCommerce platforms to enterprise cloud infrastructure. My expertise spans full-stack development, Azure cloud services, DevOps practices, and machine learning integrations.",
  location: "Sweden",
  email: "maged.hikal@yahoo.com",
  github: "https://github.com/Maged-Hikal",
  linkedin: "https://www.linkedin.com/in/maged-h-610a3b239/",
  portfolio: "https://maged-hikal.github.io/my-portfolio1/",
  yearsExperience: 8,
  projectsCompleted: 50,
  technologiesMastered: 40
};

export const skills = {
  frontend: [
    { name: "React", level: 95 },
    { name: "React Native", level: 85 },
    { name: "Angular", level: 90 },
    { name: "TypeScript", level: 92 },
    { name: "JavaScript", level: 95 },
    { name: "Vue.js", level: 75 },
    { name: "Express.js", level: 80 },
    { name: "Next.js", level: 75 },
    { name: "Pinia", level: 80 },
    { name: "SQLKnex.js", level: 75 },
    { name: "Options API", level: 75 },
    { name: "Composition API", level: 75 },
    { name: "Vite", level: 90 },
    { name: "HTML/CSS", level: 98 },
    { name: "Tailwind CSS", level: 90 },
    { name: "Bootstrap", level: 85 }
  ],
  backend: [
    { name: ".NET Core", level: 98 },
    { name: "C#", level: 98 },
    { name: "ASP.NET Core", level: 98 },
    { name: "Web API", level: 95 },
    { name: "Entity Framework Core", level: 95 },
    { name: "Blazor", level: 95 },
    { name: "Entity Framework", level: 95 },
    { name: "Node.js", level: 85 },
    { name: "RESTful APIs", level: 95 },
    { name: "GraphQL", level: 80 },
    { name: "PHP", level: 75 }
  ],
  microsoft: [
    { name: "ASP.NET Core", level: 98 },
    { name: "Azure", level: 95 },
    { name: "Azure Functions", level: 92 },
    { name: "Azure DevOps", level: 90 },
    { name: "Microsoft SQL Server", level: 95 }
  ],
  ai: [
    { name: "Python", level: 90 },
    { name: "TensorFlow", level: 85 },
    { name: "PyTorch", level: 80 },
    { name: "Scikit-learn", level: 88 },
    { name: "Machine Learning", level: 85 }
  ],
  databases: [
    { name: "SQL", level: 95 },
    { name: "PostgreSQL", level: 90 },
    { name: "MongoDB", level: 88 },
    { name: "MySQL", level: 90 },
    { name: "MSSQL", level: 95 }
  ],
  devops: [
    { name: "Docker", level: 92 },
    { name: "Kubernetes", level: 88 },
    { name: "Azure Kubernetes Service", level: 90 },
    { name: "Terraform", level: 85 },
    { name: "Azure Bicep", level: 90 },
    { name: "CI/CD", level: 95 },
    { name: "GitHub Actions", level: 90 }
  ],
  cloud: [
    { name: "Microsoft Azure", level: 95 },
    { name: "AWS", level: 85 },
    { name: "Google Cloud Platform", level: 80 },
    { name: "Azure Monitor", level: 90 },
    { name: "Cloud Architecture", level: 92 }
  ]
};

export const projects = [
  {
    id: 1,
    title: "Hospital Management System",
    category: "Node.js, Next.js",
    description: "HealthConnect is a professional, high-performance Hospital Management System built with the latest web technologies. It streamlines the healthcare experience by providing patients with easy appointment booking, a comprehensive doctor directory, and an advanced AI-powered health assistant.",
    technologies: ["Node.js", "Next.js", "TypeScript", "React19", "Tailwind", "AI-automation", "Convex", "Clerk"],
    image: "https://raw.githubusercontent.com/Maged-Hikal/hospital-system/master/public/screenshots/hero.png",
    github: "https://github.com/Maged-Hikal/hospital-system",
    demo: null,
    featured: false
  },
  {
    id: 2,
    title: "Smart Appointment Management System (Blazor)",
    category: "csharp",
    description: "Comprehensive appointment scheduling system built with .NET Core and modern frontend technologies for efficient resource management.",
    technologies: ["C#", ".NET 8", "Blazor", "EF", "AI-automation", "MSSQL", "REST-API", "JWT", "Docker", "Kubernetes"],
    image: "https://raw.githubusercontent.com/Maged-Hikal/SmartAppointmentManagementSystem/refs/heads/main/docs/images/Dashboard.png",
    github: "https://github.com/Maged-Hikal/SmartAppointmentManagementSystem",
    demo: null,
    featured: false
  },
  {
    id: 3,
    title: "AI-Driven B2B eCommerce Platform",
    category: "ai",
    description: "Led design and implementation of AI-driven solutions for B2B eCommerce operations. Developed ML models for customer behavior analysis, sales forecasting, and product recommendations.",
    technologies: ["Python", "TensorFlow", "GCP", "Angular", "BigQuery", "Cloud Functions"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal",
    demo: null,
    featured: true
  },
  {
    id: 4,
    title: "Azure Cloud Infrastructure Automation",
    category: "csharp",
    description: "Created Azure cloud-native infrastructure automation package using Azure Bicep, AKS, and Azure DevOps Pipelines for CI/CD automation with end-to-end observability.",
    technologies: ["Azure", "AKS", "Kubernetes", "Bicep", "Azure DevOps", "OpenTelemetry", "Grafana"],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal",
    demo: null,
    featured: true
  },
  {
    id: 5,
    title: "AI Job Listing Scanner & Translator",
    category: "ai",
    description: "Developed API using .NET Core and Azure Functions to scan and translate job listings using AI. Integrated with WordPress for automated page creation.",
    technologies: ["C#", ".NET Core", "Azure Functions", "Python", "AI", "WordPress"],
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal",
    demo: null,
    featured: true
  },
  {
    id: 6,
    title: "Business Management System",
    category: "fullstack",
    description: "Comprehensive business management system for consulting firms using Azure Functions to streamline time, project, and financial management.",
    technologies: ["JavaScript", "C#", ".NET Core", "Azure Functions", "Event-driven Architecture"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal",
    demo: null,
    featured: false
  },
  {
    id: 7,
    title: "Money Tracking Application",
    category: "csharp",
    description: "Personal finance management application with expense tracking, budgeting, and financial analytics capabilities.",
    technologies: ["C#", ".NET", "MSSQL", "WPF"],
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal/MoneyTracking_App",
    demo: null,
    featured: false
  },
  {
    id: 8,
    title: "Assets Tracking System",
    category: "csharp",
    description: "Enterprise asset management system for tracking and managing organizational assets with real-time monitoring and reporting.",
    technologies: ["C#", ".NET Core", "MSSQL", "Entity Framework"],
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal/Assets_Tracking_System",
    demo: null,
    featured: false
  },
  {
    id: 9,
    title: "AUTOAPI - Azure Self-Running API",
    category: "csharp",
    description: "Azure AutoApi self-running system to Check, Compare, and Register data automatically with scheduled execution.",
    technologies: ["C#", "Azure", "Azure Functions", ".NET Core", "REST API"],
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal/AUTOAPI",
    demo: null,
    featured: false
  },
  {
    id: 10,
    title: "Advanced CMS with POS System",
    category: "fullstack",
    description: "Content Management System with integrated payment order system and Point-of-Sale system. Deployed in Kubernetes/Docker environment.",
    technologies: ["React", "Angular", ".NET Core", "Tailwind CSS", "MSSQL", "Kubernetes", "Docker"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal",
    demo: null,
    featured: true
  },
  {
    id: 11,
    title: "Robot Controller System",
    category: "csharp",
    description: "Control system for robotic operations with real-time command processing and monitoring capabilities.",
    technologies: ["C#", ".NET", "IoT", "Real-time Processing"],
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal/RobotController",
    demo: null,
    featured: false
  },
  {
    id: 12,
    title: "RESTful Web API Framework",
    category: "react",
    description: "Scalable RESTful API framework with comprehensive endpoint management and documentation.",
    technologies: ["JavaScript", "Node.js", "Express", "REST API"],
    image: "https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?w=800&h=500&fit=crop",
    github: "https://github.com/Maged-Hikal/WebAPI",
    demo: null,
    featured: false
  },
  {
    id: 13,
    title: "Enterprise CMS with AWS Integration",
    category: "fullstack",
    description: "Scalable Content Management System with AWS services integration for high availability and performance.",
    technologies: [".NET Core", "Angular", "Tailwind CSS", "AWS S3", "AWS RDS", "AWS Lambda"],
    image: "https://raw.githubusercontent.com/Maged-Hikal/my-portfolio/refs/heads/main/Project_images/AWS_integration.png?token=GHSAT0AAAAAADXB2RVESKOJMKZD4RGVYTRO2ONAO3Q",
    github: "https://github.com/Maged-Hikal",
    demo: null,
    featured: false
  }
];

export const experience = [
  {
    id: 1,
    role: "Senior Software Developer | Freelance AI Developer",
    company: "Self-Employed",
    location: "Remote",
    period: "2025 - Present",
    description: "Leading AI-driven solution development using Python, TensorFlow, and GCP for B2B eCommerce. Developed ML models for customer behavior analysis, sales forecasting, and product recommendations. Built interactive applications using Angular for model visualization.",
    technologies: ["Python", "TensorFlow", "GCP", "Angular", "MLOps", "BigQuery"]
  },
  {
    id: 2,
    role: "Senior Software Developer | AI Project",
    company: "Skåne.se (ITM8)",
    location: "Sweden",
    period: "2024 - 2025",
    description: "Developed API using .NET Core and Azure Functions to scan and translate job listings using AI. Trained AI models with Python for optimal results, enabling automatic scanning and translation. Integrated with WordPress for automated publishing.",
    technologies: [".NET Core", "C#", "Azure Functions", "Python", "AI", "WordPress"]
  },
  {
    id: 3,
    role: "Cloud Engineer / DevOps / Azure Architect",
    company: "Energy Company (ITM8)",
    location: "Sweden",
    period: "2024 - 2025",
    description: "Created Azure cloud-native infrastructure automation using Azure Bicep and AKS. Implemented CI/CD pipelines in Azure DevOps. Integrated OpenTelemetry with Azure Monitor and Grafana for observability and distributed tracing.",
    technologies: ["Azure", "AKS", "Kubernetes", "Azure DevOps", "Bicep", "Terraform", "OpenTelemetry", "Grafana"]
  },
  {
    id: 4,
    role: "Senior Software Developer | Business Systems",
    company: "REXOR AB",
    location: "Sweden",
    period: "2023 - 2024",
    description: "Developed business management system for consulting firms using Azure Functions and event-driven architecture. Streamlined time, project, and financial management with modern cloud services.",
    technologies: ["JavaScript", "C#", ".NET Core", "Azure Functions", "Event-driven Architecture"]
  },
  {
    id: 5,
    role: "Senior Software Developer | Business Systems",
    company: "Mat Gross i Lycksele AB",
    location: "Sweden",
    period: "2019 - 2023",
    description: "Developed advanced CMS with payment order and POS system using Flutter, React, Angular, and .NET Core. Deployed in Kubernetes/Docker environment with real-time cash register integration.",
    technologies: ["React", "Angular", ".NET Core", "Tailwind CSS", "MSSQL", "Kubernetes", "Docker", "Blazor"]
  },
  {
    id: 6,
    role: "Software Developer",
    company: "Techno MG",
    location: "Sweden",
    period: "2018 - 2019",
    description: "Developed comprehensive CMS enabling resource management and database connectivity. Utilized AWS services for scalability and reliability including S3, RDS, and Lambda.",
    technologies: [".NET Core", "Angular", "Tailwind CSS", "JavaScript", "AWS", "Entity Framework"]
  },
  {
    id: 7,
    role: "Web Developer",
    company: "Move24",
    location: "Sweden",
    period: "2016 - 2018",
    description: "Backend and database development with SQL expertise. Built CMS using PHP and JavaScript on Google Cloud Platform with AI-powered service booking and pricing.",
    technologies: ["JavaScript", "PHP", "SQL", "Node.js", "GCP", "AI"]
  },
  {
    id: 8,
    role: "Solution Architect",
    company: "Facebook",
    location: "Sweden",
    period: "2014 - 2016",
    description: "Designed and implemented technical solutions for complex business needs. Led architecture for internal systems focusing on performance, reliability, and scalability using GraphQL, React, and Node.js.",
    technologies: ["GraphQL", "React", "Node.js", "AWS"]
  }
];

export const education = [
  {
    id: 1,
    degree: "Professional System Developer .NET",
    institution: "Lexicon Malmö AB",
    location: "Malmö, Sweden",
    period: "2023 - 2024",
    description: ".NET Fullstack development covering C#, Entity Framework, LINQ, ASP.NET, MVC, Azure, and modern frontend technologies."
  },
  {
    id: 2,
    degree: "Master's Degree in Network Systems, Design, and Installation",
    institution: "Yuriy Fedkovych Chernivtsi National University",
    location: "Chernivtsi, Ukraine",
    period: "2010 - 2011",
    description: "Advanced studies in network architecture, system design, and infrastructure deployment."
  },
  {
    id: 3,
    degree: "Bachelor's Degree in Data and Network Engineering",
    institution: "Yuriy Fedkovych Chernivtsi National University",
    location: "Chernivtsi, Ukraine",
    period: "2005 - 2010",
    description: "Comprehensive foundation in data systems, network engineering, and computer science fundamentals."
  }
];

export const certifications = [
  "Microsoft Certified: Azure Solutions Architect Expert",
  "Microsoft Certified: Azure Administrator Associate",
  "Microsoft Azure Fundamentals (AZ-900)",
  "Cyber Attack Countermeasures",
  "Enterprise and Infrastructure Security",
  "Introduction to Cyber Security Specialization",
  "Real-Time Cyber Threat Detection and Mitigation",
  "ITIL",
  "OSINT LEVEL 1 and OSINT LEVEL 2",
  "Black Hat Python - Python For Pentesters",
  "Windows Penetration Testing Essentials"
];
